// src/App.js completo e corrigido
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Importando as páginas
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* Rota da Onepage Pública */}
        <Route path="/" element={<Home />} />

        {/* Nova URL Secreta de Login */}
        <Route path="/jb-login-acesso-master-control-cms" element={<Login />} />
        
        {/* Nova URL Secreta do Painel Administrativo */}
        <Route path="/jb-acesso-master-control-cms/*" element={<Dashboard />} />

      </Routes>
    </Router>
  );
}

export default App;